import * as React from "react";
import {
  ArrowUpCircleIcon,
  BarChartIcon,
  Shield,
  Lock,
  Users,
  SettingsIcon,
  HelpCircleIcon,
  SearchIcon,
  Ban,
  CheckCircle,
  Plus,
  FileText,
  BookOpen,
  AlertTriangle,
  DatabaseIcon,
  ClipboardListIcon,
  FileIcon,
  CalendarIcon,
  ActivityIcon,
} from "lucide-react";

import { NavDocuments } from "@/components/nav-documents";
import { NavMain } from "@/components/nav-main";
import { NavSecondary } from "@/components/nav-secondary";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { Logo } from "./ui/logo";

const data = {
  navMain: [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: Shield,
    },
    {
      title: "Analytics",
      url: "/dashboard/reports",
      icon: BarChartIcon,
    },
    {
      title: "Activity",
      url: "/dashboard/activity",
      icon: ActivityIcon,
    },
    {
      title: "Schedule",
      url: "/dashboard/calendar",
      icon: CalendarIcon,
    },
    {
      title: "Organizations",
      url: "/dashboard/organizations",
      icon: Users,
    },
    {
      title: "Settings",
      url: "/dashboard/settings",
      icon: SettingsIcon,
    },
  ],
  quickActions: [
    {
      title: "Block Domain",
      action: "block",
      icon: Ban,
    },
    {
      title: "Whitelist Domain",
      action: "whitelist",
      icon: CheckCircle,
    },
    {
      title: "New Policy",
      action: "policy",
      icon: Plus,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="/dashboard">
                <Logo className="h-10 w-10" />
                <span className="text-base font-semibold">Fendly</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        <NavSecondary />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
